// 项目负责人及主要参加人员
import { getRuleLen, getRuleNumber, requiredRule } from '../../../../utils/rules';
import { Input, Form } from '@roo/roo';
import React from 'react';
import { FieldList } from '../../_components/FieldList';

const { Field } = Form;

const personInfoObj = {
  name: '', // 姓名
  age: '', // 年龄
  position: '', // 职务名称
};

export const Participant = (props) => {
  return (
    <FieldList
      {...props}
      name={'personResponsible'}
      hid={true}
      maxCount={20}
      minCount={1}
      iniData={personInfoObj}
      plusText={'添加主要人员'}
      itemClassName={'form-patch bc'}
      itemStyle={{ marginTop: 32 }}
    >
      <Field
        required={true}
        rule={getRuleLen(20,true)}
        label='姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名'
        name='name'
        as={<Input maxLength={20} placeholder='请输入主要参加人员姓名' />}
      />
      <Field
        required={true}
        rule={requiredRule}
        label='年&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;龄'
        name='age'
        as={<Input maxLength={20} type='number' placeholder='请输入主要参加人员年龄' />}
      />
      <Field
        required={true}
        rule={getRuleLen(20,true)}
        label='职务名称'
        name='position'
        as={<Input maxLength={20} placeholder='请输入主要参加人员职务职称' />}
      />
    </FieldList>
  );
};
